import WebFormRepository from '@/shared/http/repositories/socialProject/web-form'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import WebFormQuestion from '@/views/tools/web-form/components/webFormQuestion/webFormQuestion.vue'
import QuestionModel from '@/shared/models/formWebQuestion'
import { IsSuccessCode } from '@/shared/utils/API'
import {toast, loading } from '@/shared/utils/UIHelper'


export default {
  name: 'EditarWebFormQuestion',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [WebFormQuestion.name]: WebFormQuestion
  },

  data: () => ({
    title: 'Questão',
    formWebQuestion: new QuestionModel(),
    isNew: false
  }),

  provide() {
    return { parentValidator: this.$validator }
  },

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Questões',
            href: this.$router.resolve({ name: 'web-form' }).href
          },
          {
            text: 'Editar questão do formulário',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getById()
  },

  methods: {
    getById() {
      loading.push()
      WebFormRepository.GetFormWebQuestionByID(this.$route.params.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()
    
          this.formWebQuestion = res.data.data
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar questão', 'ERRO')
        })
    },

    update(formWebQuestion) {
      loading.push()
      WebFormRepository.UpdateQuestion(formWebQuestion)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()
    
          loading.pop()
          toast.success('Questão editada com sucesso', 'EDITAR QUESTÃO')
          Promise.resolve()
          return this.$router.replace({ name: 'web-form' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao editar questão', 'ERRO')
        })
    }
  }
}
